export var InfoListConstants;
(function (InfoListConstants) {
  InfoListConstants["UPCHEVRONBUTTONICON"] = "UpChevronButtonIcon";
  InfoListConstants["DOWNCHEVRONBUTTONICON"] = "DownChevronButtonIcon";
  InfoListConstants["VIEW_MORE"] = "View More";
  InfoListConstants["VIEW_LESS"] = "View Less";
  InfoListConstants["BODY_PARA_SM"] = "body-para-sm";
  InfoListConstants["BODY_PARA_MD"] = "body-para-md";
  InfoListConstants["BODY_PARA_XS"] = "body-para-xs";
  InfoListConstants["BODY_PARA_MD_BOLD"] = "body-para-md-bold";
  InfoListConstants["BODY_PARA_SM_BOLD"] = "body-para-sm-bold";
  InfoListConstants["TERTIARY"] = "tertiary";
  InfoListConstants["MD"] = "md";
  InfoListConstants["SM"] = "sm";
})(InfoListConstants || (InfoListConstants = {}));